// 系统设置=>分类管理
import request from '@/plugins/axios'

const API_LIST = {
  CLASSIFY_LIST: '/labelClass/list',   //分类查询
  CLASSIFY_ADD: '/labelClass/addClass',    //新增分类
  CLASSIFY_UPDATE: '/labelClass/updateClass', //修改分类
  CLASSIFY_UPDATE_STATUS: '/labelClass/updateStatus', //修改分类状态
  CLASSIFY_STATISTICS: '/labelClass/classStatistics', //分类统计
}
//获取分类列表
export function getClassifyListApi(params) {
  return request({ url: API_LIST.CLASSIFY_LIST, method: 'get', params})
}

//获取分类统计
export function getClassifyStatisticsApi(params) {
  return request({ url: API_LIST.CLASSIFY_STATISTICS, method: 'get', params})
}

//新增分类
export function addClassifyApi(data) {
  return request({ url: API_LIST.CLASSIFY_ADD, method: 'post', data})
}

//修改分类信息
export function updateClassifyApi(data) {
  return request({ url: API_LIST.CLASSIFY_UPDATE, method: 'post', data})
}

//修改分类状态
export function updateClassifyStatusApi(data) {
  return request({ url: API_LIST.CLASSIFY_UPDATE_STATUS, method: 'post', data})
}
